module.exports = __webpack_public_path__ + "media/images/Composz-logo-black-trans-da502d86.png";